import React from 'react';

import { ListCard } from '../../helpers/list-page/interfaces/list-card.interface';
import ImageWrapper from '../image-wrapper/Image-wrapper';

interface CardLogoProps {
  card: ListCard;
  className?: string;
}

export const CardLogo = ({ card, className }: CardLogoProps) => {
  if (card.logo) {
    const aspectRatio =
      card.logo?.width && card.logo?.height
        ? parseInt(card.logo.width) / parseInt(card.logo.height)
        : undefined;

    const isNearlySquare =
      typeof aspectRatio === 'number' && Math.abs(aspectRatio - 1) < 0.1;

    const classNames = className?.length
      ? className + ` ${!isNearlySquare ? 'border border-brand-grey-2' : ''}`
      : `!absolute top-6 left-6 w-16 h-16 bg-brand-white rounded-[12px] sm:rounded-lg flex items-center justify-center ${!isNearlySquare ? 'border border-brand-grey-2' : ''}`;

    return (
      <ImageWrapper
        url={card.logo?.url || ''}
        alt={
          card.logo?.description ? card.logo.description : 'alt text not found'
        }
        className={classNames}
        imgClassName={
          isNearlySquare
            ? '!object-contain rounded-[12px] border border-brand-grey-2'
            : '!object-contain max-w-full max-h-full p-1'
        }
        width={card.logo?.width ? parseInt(card.logo.width) : undefined}
        height={card.logo?.height ? parseInt(card.logo.height) : undefined}
      />
    );
  }
  return null;
};
